import './OtSolanoCard.css';

export interface OtSolanoCardProps {
  /** Extra class names for positioning/sizing the card from a parent layout. */
  className?: string;
}

export default function OtSolanoCard({ className }: OtSolanoCardProps) {
  return (
    <div className={['ot-card', className].filter(Boolean).join(' ')}>
      <p className="ot-card__tagline">
        Ot Solano <span aria-hidden="true">–</span> Dissenyador gràfic
      </p>
      <img src="/Logo-1080x1080.png" alt="Ot Solano" />

      <p className="ot-card__contact">
        <a href="https://wa.me/+34683439633" target="_blank" rel="noreferrer">
          +34 683 43 96 33
        </a>
        {' – '}
        <a href="mailto:otsolano.m@gmail.com">otsolano.m@gmail.com</a>
        {' – '}
        <a
          href="https://instagram.com/otsolano"
          target="_blank"
          rel="noreferrer"
        >
          @otsolano
        </a>
      </p>
    </div>
  );
}
